/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Box, theme } from "@nordcloud/gnui";
import { DASHBOARD_MOBILE_BREAKPOINT } from "../styles";

export const TopSummaryWidgetContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.spacing02};
  align-items: stretch;

  @media (max-width: ${DASHBOARD_MOBILE_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

export const StatSummaryContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex: 0 0 340px;

  @media (max-width: ${DASHBOARD_MOBILE_BREAKPOINT}px) {
    flex: 1 0 auto;
  }
`;

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.color.border.border01};
  margin: ${theme.spacing.spacing03} 0;
`;
